/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UserOrganizationPayloadItemModel model module.
 * @module model/UserOrganizationPayloadItemModel
 * @version v1.0.0
 */
class UserOrganizationPayloadItemModel {
    /**
     * Constructs a new <code>UserOrganizationPayloadItemModel</code>.
     * @alias module:model/UserOrganizationPayloadItemModel
     */
    constructor() { 
        
        UserOrganizationPayloadItemModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UserOrganizationPayloadItemModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserOrganizationPayloadItemModel} obj Optional instance to populate.
     * @return {module:model/UserOrganizationPayloadItemModel} The populated <code>UserOrganizationPayloadItemModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserOrganizationPayloadItemModel();

            if (data.hasOwnProperty('organizationId')) {
                obj['organizationId'] = ApiClient.convertToType(data['organizationId'], 'Number');
            }
            if (data.hasOwnProperty('roleId')) {
                obj['roleId'] = ApiClient.convertToType(data['roleId'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} organizationId
 */
UserOrganizationPayloadItemModel.prototype['organizationId'] = undefined;

/**
 * @member {Number} roleId
 */
UserOrganizationPayloadItemModel.prototype['roleId'] = undefined;






export default UserOrganizationPayloadItemModel;

